import backendHttpRequest from "./backendHttpRequest";
import { config } from "../configs/repositoryConfig";
import { convertToQueryString } from "../utilities/httpUtils";

export const getPartners = async (filteredObject) => {
  const queryString = convertToQueryString(filteredObject);
  const resourceObject = {
    ...config.backendApiSettings.resources.getPartners,
  };
  const endpoint = resourceObject.endpoint;
  resourceObject.endpoint = `${endpoint}${
    queryString ? `?${queryString}` : ""
  }`;

  return await backendHttpRequest({ resourceObject });
};

export const getPartnerById = async (id) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.getPartnerById,
  };
  resourceObject.endpoint = resourceObject.endpoint.replace(":id", id);

  return await backendHttpRequest({ resourceObject });
};

export const createPartner = async (formData) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.createPartner,
  };

  return await backendHttpRequest({
    resourceObject,
    body: formData,
    isFormData: true,
  });
};

export const updatePartner = async (id, formData) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.updatePartner,
  };
  resourceObject.endpoint = resourceObject.endpoint.replace(":id", id);

  return await backendHttpRequest({
    resourceObject,
    body: formData,
    isFormData: true,
  });
};

export const removePartner = async (id) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.deletePartner,
  };
  resourceObject.endpoint = resourceObject.endpoint.replace(":id", id);

  await backendHttpRequest({ resourceObject });

  return id;
};
